var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRegisterUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.826 7.567h-.902v-.882A.68.68 0 0 0 14.248 6a.68.68 0 0 0-.674.684v.882h-.9A.68.68 0 0 0 12 8.25a.68.68 0 0 0 .674.683h.901v.883a.68.68 0 0 0 .674.684.68.68 0 0 0 .675-.684v-.883h.902a.68.68 0 0 0 .674-.683.68.68 0 0 0-.674-.684",
    fill: "url(#q8zsuv89wa)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.127 11.637c-3.034 0-5.625.485-5.625 2.423 0 1.938 2.575 2.44 5.625 2.44 3.034 0 5.625-.485 5.625-2.423 0-1.938-2.575-2.44-5.625-2.44",
    fill: "url(#wfz8qjmp6b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.126 9.79c2.066 0 3.722-1.677 3.722-3.77 0-2.092-1.656-3.77-3.722-3.77S3.404 3.928 3.404 6.02c0 2.093 1.656 3.77 3.722 3.77",
    fill: "url(#twzfkcgqxc)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "q8zsuv89wa",
    x1: 12,
    y1: 6.001,
    x2: 12,
    y2: 10.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wfz8qjmp6b",
    x1: 1.502,
    y1: 11.637,
    x2: 1.502,
    y2: 16.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "twzfkcgqxc",
    x1: 3.404,
    y1: 2.25,
    x2: 3.404,
    y2: 9.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRegisterUser);
export default __webpack_public_path__ + "static/media/ic-register-user.c89700967dcccd1a73f4a87a58b9a902.svg";
export { ForwardRef as ReactComponent };